import { buildPositionStyle } from './buildPositionStyle';

/**
 * 构造fixed定位对象
 * @param {object} position 定位信息
 * @param {number} [baseWidth=375] 设计稿基准宽度（H5: 375, PC: 960）
 * @returns {object} CSS 样式对象
 */
export function positionToStyleForFixed(position, baseWidth) {
    const style = buildPositionStyle(position, baseWidth);
    style.position = 'fixed';
    return style;
}
